import immutable from 'immutable'
import { FLEETPAGE } from '../actiontype'
const defaultState = immutable.fromJS({
    fleetList : [],
    pageNum : 0,
    total : 0
})

export const fleetpageReducer = (state = defaultState, action) => {
    switch (action.type) {
        case FLEETPAGE:
            return state.updateIn(['fleetList'], _ => (action.data.datas))
                        .updateIn(['pageNum'],_ => (action.data.currentPage))
                        .updateIn(['total'],_ => (action.data.total))
        default:
            break;
    }
    return state
}
